import { render } from "./TeamListPlaceholder.vue?vue&type=template&id=7e0757fd&scoped=true"
import script from "./TeamListPlaceholder.vue?vue&type=script&lang=js"
export * from "./TeamListPlaceholder.vue?vue&type=script&lang=js"

import "./TeamListPlaceholder.vue?vue&type=style&index=0&id=7e0757fd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e0757fd"

export default script